import Login from '../components/Login';
import PropertyConnector from '../components/Error/PropertyConnector';
import ServerError from '../components/Error/ServerError';

import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import CustomRoute from './CustomRoute';
import MainContents from '../layouts/main_contents';
import ListingSearch from '@components/ListingSearch';
import DetailPage from '@components/DetailPage';
import UserManagement from '@components/UserManagement/UserManagement';
import RoleList from '@components/RoleList/RoleList';
import Reports from '@components/Reports';
import { useSession } from '../store/sessionContext';
import Forbidden from '@components/Error/Forbidden';

export const ROUTES = {
  login: {
    id: 1,
    public: true,
    custom: false,
    path: '/Login',
    title: 'Login',
    exact: true,
    component: Login
  },
  connector: {
    id: 6,
    public: false,
    custom: true,
    path: '/property-connector/:errorCode',
    title: 'property conector',
    exact: true,
    component: PropertyConnector
  },
  serverError: {
    id: 7,
    public: false,
    custom: true,
    path: '/server-error/:errorCode',
    title: 'server error',
    exact: true,
    component: ServerError
  },
  forbidden: {
    id: 8,
    public: false,
    custom: true,
    path: '/forbidden/:errorCode',
    title: 'forbidden',
    exact: true,
    component: Forbidden
  },
  listing: {
    id: 2,
    public: false,
    custom: false,
    path: '/listing',
    exact: true,
    title: 'Listing',
    component: ListingSearch
  },
  detailPage: {
    id: 3,
    public: false,
    custom: false,
    exact: false,
    path: '/detailPage',
    title: 'Detail Page',
    component: DetailPage
  },
  userManagement: {
    id: 4,
    public: false,
    custom: false,
    exact: true,
    path: '/userManagement',
    title: 'User Management',
    component: UserManagement
  },
  roleList: {
    id: 5,
    public: false,
    custom: false,
    exact: true,
    path: '/rolelist',
    title: 'Role List',
    component: RoleList
  },
  reports: {
    id: 9,
    public: false,
    custom: false,
    exact: true,
    path: '/reports',
    title: 'Reports',
    component: Reports
  }
};

export default function Router(props: { children?: React.ReactNode }) {
  const { session } = useSession();

  const initial = () => {
    if (session.loggedIn) {
      return <Redirect to='/listing' />;
    } else {
      const authCode = window.location.search.split('=')[1] || undefined;
      if (authCode) {
        window.sessionStorage.setItem('exchange_code', authCode);
      }
      return <Redirect to='/Login' />;
    }
  };

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path='/' render={initial} />
        {Object.values(ROUTES).map((route, key) => {
          return route.public ? (
            <PublicRoute key={key} path={route.path} component={route.component} exact={route.exact} />
          ) : route.custom ? (
            <CustomRoute
              key={key}
              path={route.path}
              component={route.component}
              layout={MainContents}
              statusSession={session}
              exact={route.exact}
            />
          ) : (
            <PrivateRoute
              key={key}
              path={route.path}
              component={route.component}
              layout={MainContents}
              statusSession={session}
              exact={route.exact}
            />
          );
        })}
        <Route path='*'>
          {' '}
          <div>404</div>{' '}
        </Route>
      </Switch>
      {props.children}
    </BrowserRouter>
  );
}
